<template>
    <div class="wrapper" v-loading="loading">
        <div class="top">
            <div>
                <img :src="specDetail.headImageUrl" alt='加载失败' />
            </div>
            <div class="desc">
                <div class="t1">{{specDetail.title}}</div>
                <div class="t2">{{specDetail.sencondTitle}}</div>
            </div>
        </div>
        <div class="body">
            <div v-for="item in jobs" :key="item.id">
                <job-item :datas="item" @updateFavorite="updateFavorite"></job-item>
            </div>
            <div class="paginationWrapper">
                <pagination
                    v-model="pageIndex"
                    :total="pagination.totalRow"
                    :pageSize="10"
                    v-if="pagination.totalRow>0 && !loading"
                    @change="pageChange">
                </pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState,mapGetters } from "vuex";
import { getSpecDetail } from '@/api/common'
import JobItem from '@/views/job/components/item.vue';
export default {
    components: {
      JobItem
    },
    data(){
        return {
            loading: false,
            pageIndex: 1,
            specDetail:{}, // 这里加逗号
            specId: ''
        }
    },
    computed: {
      ...mapState({
        jobs: state => state.jobs.jobList, //工作列表
        pagination: state => state.jobs.pagination,
      }),
    },
    methods:{
        ...mapActions([
            "getJobs",
            "login",
            "addFavorite",
            "deleteFavorite",
            "changeFavoriteState",
        ]),
        pageChange(e){
            this.pageIndex = e;
            this.getJobsList();
        },
        async fetchSpecDetail(){
            this.loading = true;
            const res = await getSpecDetail(this.specId);
            this.loading = false;
            if(res.code === 200){
                this.specDetail = res.data;
            }
            else this.$message.error(res.message || '加载专题详情出错');
        },
        async getJobsList() {
            this.loading = true;
            await this.getJobs({pageSize:10,pageIndex:this.pageIndex,specialType:this.specDetail.specialType});
            this.loading = false;
        },
         //职位的收藏与取消
        async updateFavorite(id,collect){
            let idx = this.jobs.findIndex(item=>item.id === id)
            if(collect){ //取消收藏
                const res = await this.deleteFavorite(id);
                if (res) {
                    this.jobs[idx].favorite = false;
                    this.$message({
                    message: "取消收藏!",
                    type: "success"
                    });
                }else {
                    this.$message({
                    message: res.message,
                    type: "warning"
                    });
                }
            }else{ //收藏
                const res = await this.addFavorite(id);
                if (res && res.code == 200) {
                    this.jobs[idx].favorite = true;

                    this.$message({
                    message: "收藏成功!",
                    type: "success"
                    });
                } else {
                    this.$message({
                    message: res.message,
                    type: "warning"
                    });
                }
            }
        },
        getQueryParams(){
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            this.specId = id;
            console.log('ID:', id);
        }
    },
    async created(){
        this.getQueryParams(); // 获取查询参数
        await this.fetchSpecDetail();
        await this.getJobsList();
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    width: 1280px;
    margin: 30px auto 0;
    .top {
        position: relative;
        img{
            width: 100%;
            height: auto;
        }
        .desc{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            width: 50%;
            text-align: center;
            .t1{
                font-size: 18px;
                font-weight: bold;
            }
            .t2{
                font-size: 14px;
                white-space: wrap;
            }
        }
    }
    .body{
        margin-top: 20px;
        /deep/.content{
           width: 100%;
           display: flex;
           justify-content: space-between;
        }
        // /deep/.content-left{
        //     width: 700px;
        // }
        // /deep/.content-otherinfo{
        //     width: auto;
        // }
        .paginationWrapper{
            display: flex;
            justify-content: center;
        }
    }
}
</style>